export const defaultGlobalObjectKey = 'faro';
export const defaultBatchingConfig = {
    enabled: true,
    sendTimeout: 250,
    itemLimit: 50,
};
//# sourceMappingURL=const.js.map